import moment from 'moment';
import { Invoice } from 'shared/classes/Billing';

function DiscountCode(data){
	var self = this;
	self.type = "DiscountCode"

    self.rootvm = data.rootvm;

	self.discount_code_uuid = ko.observable(data.discount_code_uuid);
    self.code = ko.observable(data.code);
    self.discount_amount = ko.observable(data.discount_amount);
    self.expiration_date = ko.observable(data.expiration_date);
    self.minimum_amount = ko.observable(data.minimum_amount);
    self.currency = ko.observable(data.currency);
    self.can_use_pass_the_hat = ko.observable(data.can_use_pass_the_hat);
    self.can_use_pro_artist = ko.observable(data.can_use_pro_artist);

    self.image = ko.observable(data.visible);

    self.image_path_de = ko.observable(data.image_path_de);
    self.image_path_en = ko.observable(data.image_path_en);

    self.visible = ko.observable(data.visible);
    self.deactivated = ko.observable(data.deactivated);

    self.redeemed_invoices = ko.observableArray([]);


    self.inserted = ko.observable(new moment(data.inserted));

    // How many times has it been used
    self.uses_count = ko.observable(data.uses_count);

    if(self.uses_count() === undefined){
        self.uses_count(0);
    }


    self.toggle_deactivate = function(state){
        return $.ajax({

            url: '/api/admin/discount-code/toggle-deactivated',
            type: 'POST',
            data:ko.toJSON({
                deactivated: state,
                discount_code_uuid: self.discount_code_uuid()
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){
                   self.deactivated(state);
                   notyf.success(state ? 'Deactivated' : 'Reactivated');
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
            }
        });
    }



    self.toggle_visible = function(state){
        return $.ajax({

                url: '/api/admin/discount-code/toggle-visible',
                type: 'POST',
                data:ko.toJSON({
                    visible: state,
                    discount_code_uuid: self.discount_code_uuid()
                }),
                processData: false,

                contentType: "application/json; charset=utf-8",

                success: function (data) {

                   if (data.success){
                       self.visible(state);
                       notyf.success(state ? 'Shown' : 'Hidden');
                   }
                   else{
                       notyf.error(data.message);
                   }

                },
                error: function (jqXHR, errorStatus, thrownError) {
                    var response = jQuery.parseJSON(jqXHR.responseText);
                    notyf.error(response.message);
                },
                complete: function(){
                }
            });
    }

    self.extra_notes = ko.observable(data.extra_notes);
    self.new_extra_notes = ko.observable(data.extra_notes);
    self.editing_extra_notes = ko.observable(false);
    self.cancel_extra_notes = function(){

        self.new_extra_notes(self.extra_notes());
        self.editing_extra_notes(false);
    }

    self.save_extra_notes = function(){

        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/discount-code/extra-notes',
            type: 'POST',
            data:ko.toJSON({
                discount_code_uuid: self.discount_code_uuid(),
                extra_notes: self.new_extra_notes()
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){

                   self.extra_notes(data.extra_notes);
                   self.new_extra_notes(data.extra_notes);
                   self.editing_extra_notes(false);
                   notyf.success("Saved!");
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
            }
        });
    };


    self.lookup_redeemed_invoices = function(){

        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/discount-code/invoices',
            type: 'GET',
            data:{
                discount_code_uuid: self.discount_code_uuid()
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.redeemed_invoices(ko.utils.arrayMap( data.discount_code.redeemed_invoices || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new Invoice(x);
                    }));

            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

};

export function DiscountCodeViewModel(data) {

    var self = this;
    self.type = "DiscountCodeViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = function(){

        if (!self.initialized()){
          self.lookup_discount_codes().then(function(){
                console.log('done looking up discount codes');
                self.initialized(true);
          })};
    }

    self.show_hidden = ko.observable(false);

    self.discount_codes = ko.observableArray([]);

    self.new_code = ko.observable();
    self.new_discount_amount = ko.observable();
    self.new_minimum_amount = ko.observable();
    self.new_expiration_date = ko.observable();
    self.new_can_use_pass_the_hat = ko.observable();
    self.new_can_use_pro_artist = ko.observable();
    self.new_currency = ko.observable();

    self.dc_info_modal = undefined;
    self.selected_dc_info = ko.observable(new DiscountCode({}));

    self.lookup_invoices_for_dc= function(dc){
        self.selected_dc_info(dc);
        self.selected_dc_info().lookup_redeemed_invoices();
    };


    self.add_click = function(){

        return $.ajax({

            url: '/api/admin/discount-code',
            type: 'POST',
            data:ko.toJSON({
                code: self.new_code(),
                discount_amount: self.new_discount_amount(),
                expiration_date : self.new_expiration_date(),
                minimum_amount: self.new_minimum_amount(),
                currency: self.new_currency(),
                can_use_pass_the_hat: self.new_can_use_pass_the_hat() === true,
                can_use_pro_artist: self.new_can_use_pro_artist() === true
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){

                   data.discount_code.rootvm = self.rootvm;
                   self.discount_codes.push(new DiscountCode(data.discount_code));

                   notyf.success("Added!");
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
            }
        });
    }


    self.lookup_discount_codes = function(){
        self.rootvm.is_busy(true);

        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/discount-codes',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.discount_codes(ko.utils.arrayMap( data.discount_codes || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new DiscountCode(x);
                    }));

            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };
};
